import axios from "axios";

import { getBaseURL } from "@vega-core/utils/global";

export const BFF_SESSION_PATH = "/api/authentication/v1/oauth2/session";

export async function isBffSessionActive(): Promise<boolean> {
  try {
    const response = await axios.get(`${getBaseURL()}${BFF_SESSION_PATH}`, {
      withCredentials: true,
    });

    return response.status >= 200 && response.status < 300;
  } catch {
    return false;
  }
}
